/**
 * Suppliers whose blank-goods POs the back office places on the
 * distributor's OWN account. tf-deconetwork fetches that credential from us
 * (GET /api/internal/distributors/<id>/<supplier>-credentials) in its
 * distributor tier, which is SanMar-only today: our S&S callback exists but
 * is not called yet. Every other supplier's credential is used for PRICING
 * only, and the Integrations copy must say so.
 *
 * Add a supplier_key here when tf-deconetwork starts calling its callback.
 */
export const SUPPLIERS_ORDERED_ON_DISTRIBUTOR_ACCOUNT = Object.freeze(["sanmar"]);
